import React from "react"; 
import TableRoutesListPageContainer from "./TableRoutesListPageContainer";

export class TableRoutesListPage extends React.Component {
  render() {
    return <TableRoutesListPageContainer {...this.props} />;
  }
}
